export default "__VITE_ASSET__CpZM_K2O__"